import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import {TradeEntity} from '../Entities/TradeEntity.js'
import {HTTPTransactionRepository} from '../Repositories/HTTPTransactionRepository.js'

/**
 * @implements UseCase
 */
class GetBuyerTradeDataTransactionsUseCase extends UseCase {
  #httpTransactionsRepository

  constructor({httpTransactionsRepository}) {
    super()
    this.#httpTransactionsRepository = httpTransactionsRepository
  }

  static create({config}) {
    return new GetBuyerTradeDataTransactionsUseCase({
      httpTransactionsRepository: HTTPTransactionRepository.create({config})
    })
  }

  @inlineError
  async execute({tradeId}) {
    const tradeEntity = TradeEntity.create({
      id: tradeId
    })

    const [error, response] = await this.#httpTransactionsRepository.getBuyerTradeData(tradeEntity)

    if (error) return Promise.reject(error)

    return response.toJSON()
  }
}

export const factory = GetBuyerTradeDataTransactionsUseCase.create
